/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum SchedulingWaitingListAliases {
  AUTOCOMPLETE_ESTABLISHMENT = 'autocomplete-establishment',
  AUTOCOMPLETE_EXAM_PROCEDURE = 'autocomplete-exam-procedure',
  AUTOCOMPLETE_FIELD_PHYSICIAN = 'autocomplete-field-physician',
  AUTOCOMPLETE_SCHEDULE_TYPE = 'autocomplete-schedule-type',
  AUTOCOMPLETE_SPECIALITY = 'autocomplete-speciality',
  AUTOCOMPLETE_URGENCY_REASON = 'autocomplete-urgency-reason',
  BUTTON_CANCEL = 'button-cancel',
  BUTTON_CONFIRM = 'button-confirm',
  CARD_AVATAR_WITH_TWO_SUBTITLES_0 = 'card-avatar-with-two-subtitles-0',
  CHECKBOX_IE_URGENT = 'checkbox-ie-urgent',
  CONTEXTUAL_BAR_WAITING_LIST = 'contextual-bar-waiting-list',
  DATE_FIELD_AVAILABLE_PERIOD = 'date-field-available-period',
  DATE_FIELD_DESIRED_DATE = 'date-field-desired-date',
  EXAM_AVATAR = 'exam-avatar',
  EXAMS_FETCH = 'exams-fetch',
  FETCH_ESTABLISHMENT = 'fetch-establishment',
  FETCH_FIELD_PHYSICIAN = 'fetch-field-physician',
  FETCH_SPECILITY = 'fetch-specility',
  FETCH_URGENCY_REASON = 'fetch-urgency-reason',
  FIELD_AVAILABLE_PERIOD = 'field-available-period',
  FIELD_AVAILABLE_PERIOD_READONLY = 'field-available-period-readonly',
  FIELD_CONTACT_NAME = 'field-contact-name',
  FIELD_CONTACT_NUMBER = 'field-contact-number',
  FIELD_DESIRED_DATE = 'field-desired-date',
  FIELD_ESTABLISHMENT = 'field-establishment',
  FIELD_EXAMS = 'field-exams',
  FIELD_IE_URGENT = 'field-ie-urgent',
  FIELD_NOTE = 'field-note',
  FIELD_PHYSICIAN = 'field-physician',
  FIELD_SCHEDULE_TYPE = 'field-schedule-type',
  FIELD_SPECIALITY = 'field-speciality',
  FIELD_URGENCY_REASON = 'field-urgency-reason',
  FORM_WAITING_LIST = 'form-waiting-list',
  GLOBAL_ACTIONS_WAITING_LIST = 'global-actions-waiting-list',
  INPUT_AVAILABLE_PERIOD_READONLY = 'input-available-period-readonly',
  INPUT_CONTACT_NAME = 'input-contact-name',
  LAYOUT_WAITING_LIST = 'layout-waiting-list',
  MAPPER_ESTABLISHMENT = 'mapper-establishment',
  MAPPER_EXAM_AVATAR = 'mapper-exam-avatar',
  MAPPER_FIELD_PHYSICIAN = 'mapper-field-physician',
  MAPPER_SCHEDULE_TYPE = 'mapper-schedule-type',
  MAPPER_SPECILITY = 'mapper-specility',
  MAPPER_URGENCY_REASON = 'mapper-urgency-reason',
  PANEL_GENERAL = 'panel-general',
  PHONE_NUMBER_CONTACT = 'phone-number-contact',
  TEXT_AREA_0 = 'text-area-0',
  TEXT_ESTABLISHMENT = 'text-establishment',
  TEXT_SCHEDULE_TYPE = 'text-schedule-type',
  TEXT_SPECIALITY = 'text-speciality',
  TEXT_URGENCY_REASON = 'text-urgency-reason',
}
export { SchedulingWaitingListAliases };
